import { Box, Typography } from "@mui/material";

export enum WidgetCardCountsType {
  total = "total",
  completed = "completed",
}

export const WidgetCardCounts = ({
  count,
  type,
}: {
  count: number;
  type: WidgetCardCountsType | any;
}) => {
  const getTitle = () => {
    if (WidgetCardCountsType.total === type) {
      return <Typography color={"#B93815"}>Всего</Typography>;
    } else if (WidgetCardCountsType.completed === type) {
      return <Typography color={"#027A48"}>Завершено</Typography>;
    }
    return <Typography color={"inherit"}>{type}</Typography>;
  };

  return (
    <Box
      sx={{
        display: "inline-block",
        p: "24px",
        borderRadius: "12px",
        border: "1px solid #EAECF0",
        minWidth: "240px",
        boxShadow:
          "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
      }}
    >
      <Box
        sx={{
          mb: "8px",
        }}
      >
        {getTitle()}
      </Box>
      <Typography fontWeight={600} fontSize={"36px"} lineHeight={"44px"}>
        {count}
      </Typography>
    </Box>
  );
};
